var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 9.1667H4.50861L8.92527 4.75837C9.08219 4.60145 9.17035 4.38862 9.17035 4.1667C9.17035 3.94478 9.08219 3.73195 8.92527 3.57503C8.76835 3.41811 8.55553 3.32996 8.33361 3.32996C8.11169 3.32996 7.89886 3.41811 7.74194 3.57503L1.90861 9.40837C1.8305 9.48583 1.76851 9.578 1.7262 9.67955C1.68389 9.7811 1.66211 9.89002 1.66211 10C1.66211 10.11 1.68389 10.219 1.7262 10.3205C1.76851 10.4221 1.8305 10.5142 1.90861 10.5917L7.74194 16.425C7.81941 16.5031 7.91158 16.5651 8.01313 16.6074C8.11468 16.6497 8.2236 16.6715 8.33361 16.6715C8.44362 16.6715 8.55254 16.6497 8.65409 16.6074C8.75564 16.5651 8.84781 16.5031 8.92527 16.425C9.00338 16.3476 9.06538 16.2554 9.10768 16.1538C9.14999 16.0523 9.17177 15.9434 9.17177 15.8334C9.17177 15.7234 9.14999 15.6144 9.10768 15.5129C9.06538 15.4113 9.00338 15.3192 8.92527 15.2417L4.50861 10.8334H17.5003C17.7213 10.8334 17.9332 10.7456 18.0895 10.5893C18.2458 10.433 18.3336 10.221 18.3336 10C18.3336 9.77902 18.2458 9.56706 18.0895 9.41078C17.9332 9.2545 17.7213 9.1667 17.5003 9.1667Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.29f0b2e4a8a4b1a952ba34a9e5197a67.svg";
export { ForwardRef as ReactComponent };